import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../nest-api";
import { RequestGetActivityDto, ResponseGetActivityDto } from '../gd-only/dto/activity.dto';
import { ResponsePaging } from '../nest-responses';

@Injectable()
export class ActivityProvider {

  private _service: string = 'attendance';
  private _model: string = 'activity';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getSearchEmployee(limit: string | number, page: string | number, fullName: string): Observable<any> {

    const _method: string = 'GET';
    const _func: string = 'getSearchEmployee';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof page !== 'undefined' && page !== null) _urlParams.page = page;
    if (typeof fullName !== 'undefined' && fullName !== null) _urlParams.fullName = fullName;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }


  getActivity(payload: RequestGetActivityDto) {
    const method: string = "GET";
    const func: string = "getActivity";
    const params: any = {};
    const urlParams: any = payload;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApiProvider.urlBuilder(method, this._model, func, params, urlParams, null);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetActivityDto>>(method, url, params, urlParams, body, contentType);
  }

  public createActivity(params: any): Observable<any> {

    const _method: string = 'POST';
    const _func: string = 'createActivity';
    const _params: any = params || {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, {}, _urlParams, this._service);
    return this.nestApiProvider.request(_method, _url, _params, _urlParams, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/activity-recording/activity.ts